module.exports = __webpack_public_path__ + "img/big_1_78.2f5f74aa.png";